export default __webpack_public_path__ + "static/media/scan_qr.e3a65bea.jpg";